import React from 'react';
import { Helmet } from 'react-helmet';
import './Downloads.css';

const pageUrl = 'https://jerryevanoff.com/downloads';
const pageTitle = 'Downloads | Jerry Evanoff';
const pageDescription = 'Download bonus content and archives from author Jerry Evanoff, writer of the Sam Norris Murder Mystery Series and time travel science fiction.';

const Downloads = () => {
  return (
    <div className="year-download">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="author" content="Jerry Evanoff" />
        <link rel="canonical" href={pageUrl} />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="year-download-container">
        <h1 className="year-download-title">Pro Football Helper Files</h1>

        <ul className="year-download-list">
          <li className="year-download-item">
            <h2 className="year-download-subtitle">2025 NFL</h2>

            <a
              href="/downloads/2025.zip"
              className="year-download-button"
              download
            >
              Download 2025.zip
            </a>
          </li>
        </ul>

        <div className="year-download-video-section">
          <p className="year-download-note">
            Click Below to use Dave Gardner's set up video to set up your season.
          </p>

          <a
            href="https://www.youtube.com/watch?v=hzIJ7O9Iqsw"
            target="_blank"
            rel="noopener noreferrer"
            className="year-download-video-link"
          >
            <img
              src="/images/PFH.png"
              alt="Dave Gardner's Pro Football Helper set up video"
              className="year-download-video-thumb"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Downloads;